import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const customFontSize = '14px';

const rowStyle = {
  fontSize: customFontSize,
  color: colors.black,
  fontWeight: fonts.weights.normal,
  letterSpacing: '0.25px',
  lineHeight: '20px',
};

const useStyles = makeStyles({
  accordionContainer: {
    overflow: 'auto',
    '& .MuiAccordionDetails-root': {
      padding: 0,
      minWidth: '1500px',
      overflowX: 'auto',
    },
  },
  accordionSummary: {
    backgroundColor: colors.planningGridAccordionSumaryBg,
    minHeight: '72px',
    minWidth: '1500px',
  },

  // root: {
  //   display: 'flex',
  //   flexDirection: 'column',
  // },
  summary: {
    backgroundColor: colors.planningGridAccordionSumaryBg,
    minHeight: '72px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  buttonsActionsContainer: {
    display: 'flex',
    width: '100%',
    '& .MuiButton-text': {
      fontSize: customFontSize,
      fontWeight: fonts.weights['extra-bold'],
      letterSpacing: '1.25px',
      lineHeight: '16px',
    },
  },
  buttonsActionsContainerLeft: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-start',
  },
  buttonsActionsContainerRight: {
    justifyContent: 'flex-end',
    display: 'flex',
    width: '100%',
  },
  container: {
    background: colors.white,
    width: '100%',

    '& .MuiTable-root': {
      borderCollapse: 'collapse',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: '0',
      background: '#fff',
      zIndex: 999,
      boxShadow:
        'inset 0 1px 0 1px solid rgba(224, 224, 224, 1), inset 0 -1px 0 1px solid rgba(224, 224, 224, 1)',
    },
    // Table root
    '& > div:first-child': {
      height: '100%',
      paddingBottom: '16px',
    },
    // Table container
    '& > div:first-child > div': {
      width: '100%',
      maxHeight: '70vh',
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    '& .MuiTableCell-root': {
      ...rowStyle,
      maxHeight: '64px',
      wordWrap: 'break-word',
    },
    '& .Mui-checked': {
      color: colors.primary,
    },
  },
  roots: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px ',
  },
  button: {
    width: '20px',
    padding: '6px',
  },

  redStatus: { color: '#ff00009e' },
  yellowStatus: { color: '#ffff00a0' },
  greenStatus: { color: '#008000a7' },
  buttonGroup: {
    margin: '8px 4px',
    border: '1px solid #000',
    width: '110px',
  },

  scrollDiv: {
    width: '100%',
    overflowX: 'auto',
  },
  hiddenScrollDiv: {
    height: '1px',
  },
  selectedRows: {
    backgroundColor: colors.primary02,
    borderLeft: `1px solid ${colors.primary}`,
  },
  tooltipLabel: {
    ...rowStyle,
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  disabledRow: {
    '& .MuiTableCell-root': {
      color: colors.darkGray,
    },
  },

  tableTitle: {
    fontSize: customFontSize,
    color: colors.black,
    fontWeight: fonts.weights.medium,
    letterSpacing: '0.1px',
    lineHeight: '24px',
  },

  iconButtonContainer: {
    padding: 0,
  },

  buttonText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    textTransform: 'none',
    color: colors.primary,
    textDecoration: 'underline',

    '&:hover': {
      textDecoration: 'underline',
      backgroundColor: colors.white,
    },
  },
  editableInput: {
    '& .MuiInput-underline': {
      border: 0,
    },
  },
});

export default useStyles;
